import type { CSSProperties, ReactNode } from "react";
import type { TippyProps } from "@tippyjs/react";
import Tippy from "@tippyjs/react";

interface AnchorRect {
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
}

interface VirtualAnchorPopupProps
  extends Omit<TippyProps, "children" | "content" | "visible"> {
  anchorRect?: AnchorRect;
  children: ReactNode;
  show: boolean;
}

export const VirtualAnchorPopup = ({
  show,
  children,
  anchorRect,
  ...rest
}: VirtualAnchorPopupProps) => {
  const { left = 0, right = 0, top = 0, bottom = 0 } = anchorRect || {};

  const styles: { toolbar: CSSProperties } = {
    toolbar: {
      position: "fixed",
      ...{ left, right, top, bottom },
      width: right - left,
      height: bottom - top,
      zIndex: -1,
    },
  };

  return (
    <Tippy
      interactive
      animation="false"
      duration={0}
      arrow
      delay={0}
      theme="light-border"
      allowHTML
      appendTo="parent"
      visible={show}
      content={children}
      {...rest}
    >
      <button type="submit" style={styles.toolbar} />
    </Tippy>
  );
};
